// https://ampersand-stg.sequoiacap.com/login?redirect=javascript:alert(document.cookie)
// https://ampersand-stg.sequoiacap.com/auth?redirect=javascript:alert(document.cookie)
// https://ampersand-stg.sequoiacap.com/auth?redirect=https://www.google.com

import URLUtils from "@sequoiacap/shared/utils/URLUtils";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

/** Ensure the `maybeNext` is an allowed domain
 *
 * NOTE: both of these will be rejected:
 * [attack]  http://localhost:3000/login?redirect=java%0D%0Ascript%0D%0A:alert(%22h%22)
 * [legit]  http://localhost:3000/login?redirect=resources
 * The first one will look like path "java" to URLUtils.isUrl but when interpreted as a redirect, will be "javascript" and would execute.
 *
 */
export function ensureRedirectIsSafe(maybeNext: string | undefined) {
  const next = maybeNext ?? "/";
  if (
    !next.startsWith("/") &&
    URLUtils.safeUrl(next)?.hostname !== publicRuntimeConfig.domain
  ) {
    // console.error(
    //   "Invalid redirect URL",
    //   next,
    //   ", redirecting to /",
    //   URLUtils.safeUrl(next)?.hostname,
    //   publicRuntimeConfig.domain,
    // );
    return "/";
  }
  return next;
}
